import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setEmployeeContext, setNavigationContext } from '../../global/ducks/app-context';
import { getOrganization } from '../../global/ducks/organization-prc-api';
import { BillingAccountSessionStorageState, GetSessionStorageValue, InstitutionSessionStorageState, TcsmReduxSessionStorageKeys } from '../../global/helpers/session-storage-helper';
import { EmployeeContext, NavigationContext } from '../../global/models/app-context-model';
import { setCurrentBillingAccount } from '../../pages/arc/features/billing-accounts/billing-accounts-slice';
import { Employee } from '../../pages/arc/features/employment/employment-model';
import { setCurrentEmployee } from '../../pages/arc/features/employment/employment-slice';
import { Group } from '../../pages/arc/features/groups/groups-model';
import { setCurrentGroup } from '../../pages/arc/features/groups/groups-slice';
import { dispatchResetInstitutionClientNumber, dispatchSetCurrentInstitution, setInstitutionClientNumber, setInstitutionGuid } from '../../pages/arc/features/institutions/institution-slice';

export function useInitialState() {
	const dispatch = useDispatch();
	useEffect(() => {
		const defaultInstitutionState = JSON.parse(GetSessionStorageValue(TcsmReduxSessionStorageKeys.INSTITUTION_SELECT)) as InstitutionSessionStorageState;
		const defaultEmployeeState = JSON.parse(GetSessionStorageValue(TcsmReduxSessionStorageKeys.EMPLOYEE_SELECT)) as Employee;
		const defaultGroupState = JSON.parse(GetSessionStorageValue(TcsmReduxSessionStorageKeys.GROUP_SELECT)) as Group;
		const defaultBillingAccountState = JSON.parse(GetSessionStorageValue(TcsmReduxSessionStorageKeys.BILLING_ACCOUNT_SELECT)) as BillingAccountSessionStorageState;
		const defaultParticipantState = JSON.parse(GetSessionStorageValue(TcsmReduxSessionStorageKeys.PARTICIPANT_SELECT)) as Employee;
		const defaultGroupAdminState = JSON.parse(GetSessionStorageValue(TcsmReduxSessionStorageKeys.GROUP_ADMIN_SELECT)) as Employee;
		const defaultInstitutionAdminState = JSON.parse(GetSessionStorageValue(TcsmReduxSessionStorageKeys.INSTITUTION_ADMIN_SELECT)) as Employee;


		if (defaultInstitutionState) {
			dispatch(setInstitutionClientNumber(defaultInstitutionState?.institutionId));
			dispatch(setInstitutionGuid(defaultInstitutionState?.guid));
			dispatch(setNavigationContext(NavigationContext.Institution));
			dispatch(getOrganization(defaultInstitutionState?.institutionId, dispatchSetCurrentInstitution(dispatch), dispatchResetInstitutionClientNumber(dispatch)));
		}
		if (defaultEmployeeState) {
			dispatch(setCurrentEmployee(defaultEmployeeState));
			dispatch(setEmployeeContext(EmployeeContext.InstitutionEmployee));
			dispatch(setNavigationContext(NavigationContext.Institution));
		}
		if (defaultGroupState) {
			dispatch(setCurrentGroup(defaultGroupState));
			dispatch(setNavigationContext(NavigationContext.None));
		}
		if (defaultBillingAccountState) {
			dispatch(setCurrentBillingAccount(defaultBillingAccountState?.billingAccount));
			dispatch(setInstitutionClientNumber(defaultBillingAccountState?.clientNumber));
			dispatch(setNavigationContext(NavigationContext.BillingAccount));
		}
		if (defaultParticipantState) {
			dispatch(setCurrentEmployee(defaultParticipantState));
			dispatch(setEmployeeContext(EmployeeContext.Participant));
			dispatch(setNavigationContext(NavigationContext.BillingAccount));
		}
		if (defaultGroupAdminState) {
			dispatch(setCurrentEmployee(defaultGroupAdminState));
			dispatch(setEmployeeContext(EmployeeContext.GroupAdmin));
			dispatch(setNavigationContext(NavigationContext.GroupAdmin));
		}
		if (defaultInstitutionAdminState) {
			dispatch(setCurrentEmployee(defaultInstitutionAdminState));
			dispatch(setEmployeeContext(EmployeeContext.InstitutionAdmin));
			dispatch(setNavigationContext(NavigationContext.Institution));
		}
	}, []);

}